// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.c-button-til-solu {
  padding-top: 0px !important;
  position: relative;
  top: 0px !important;
}

.clear-option {
  text-align: center;
  /* Setur textann í miðju */
}

.clear-text {
  font-style: italic;
}

.mat-button,
.mat-raised-button,
.mat-icon-button,
.mat-stroked-button,
.mat-flat-button,
.mat-fab,
.mdc-button__label,
.mat-mini-fab {
  color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/properties-sold-search-home/properties-sold-search-home.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,2BAAA;EACA,kBAAA;EACA,mBAAA;AAEF;;AACA;EACE,kBAAA;EACA,0BAAA;AAEF;;AACA;EACE,kBAAA;AAEF;;AACA;;;;;;;;EAQE,uBAAA;AAEF","sourcesContent":[".c-button-til-solu {\r\n  padding-top: 0px !important;\r\n  position: relative;\r\n  top: 0px !important;\r\n}\r\n\r\n.clear-option {\r\n  text-align: center;\r\n  /* Setur textann í miðju */\r\n}\r\n\r\n.clear-text {\r\n  font-style: italic;\r\n}\r\n\r\n.mat-button,\r\n.mat-raised-button,\r\n.mat-icon-button,\r\n.mat-stroked-button,\r\n.mat-flat-button,\r\n.mat-fab,\r\n.mdc-button__label,\r\n.mat-mini-fab {\r\n  color: white !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
